export const EVENT_GA = 'eventGA';
export const VIRTUAL_PAGE_LOAD = 'virtualPageLoadingDataLayer';

export const GA_DEFAULT_PAYLOAD = {
  event: EVENT_GA,
  valueGA: 0,
  nonInteraction: 0,
};

export const BE = 'Booking Engine';
export const BE_OPTION_CONFIRMATION = 'BE_option_confirmation';
export const BE_OPTION_ERROR = 'BE_option_error';
export const BE_TRACKING = 'trackingBE';
export const BE_MORE_ACCOMMODATIONS = 'BE_moreRooms';
export const BE_MODIFY_TRANSPORT = 'BE_modifyTransport';
export const BE_MODIFY_TRANSPORT_ERROR = 'BE_modifyTransportError';
export const CONNECTION_STATUS_LOGGED = 'alreadyLogged';
export const CONNECTION_STATUS_QUICK_LOGGED = 'quickLogged';
export const CONNECTION_STATUS_NOT_LOGGED = 'notLogged';

export const PLE = 'PLE';
export const PLE_OPTION = 'PLE_option';
export const PLE_QUICK = 'PLE_quick';
export const PLE_QUICK_OPTION = 'PLE_quick_option';

export const PLE_TRACKING = 'trackingPLE';

export const SEARCH_LABEL_GA_MAP = {
  resort: 'village',
  activity: 'activities',
  area: 'destination',
  country: 'destination',
  none: 'searchCTA',
};

export const SHOPPING_TRACKING = 'trackingSHOP';
export const SHOPPING_LAST_VISITED_PRODUCTS = 'SHOP_lastVisitedProducts';
export const SHOPPING_LAST_VISITED_PRODUCTS_NUMBER = 10;

export const SUMMER_DATE_START = 501;
export const SUMMER_DATE_END = 1102;

export const PROPOSAL_CATEGORIES = {
  '000017': 'club', // club
  '000048': 'club', // club seaside view
  '000061': 'superior', // superior
  '000018': 'deluxe', // deluxe
  '000039': 'deluxe', // deluxe zen
  '000047': 'deluxe', // deluxe seaside view
  '000056': 'deluxe', // Deluxe Exclusive
  '000019': 'suite', // suite
  '000020': 'suite', // suite 5 tridents
};

export const STATIC_PAGE_TYPES = {
  BE: 'booking-engine',
  PLE: 'ple',
  PLE_PAYMENT_CONFIRMATION: 'ple-payment-confirmation',
  SHOPPING_HOME: 'home',
  SHOPPING_NEWSLETTER: 'newsletter',
  SHOPPING_PREBOOKING: 'prebooking',
  SHOPPING_SEARCH: 'search',
  SHOPPING_SITEPLAN: 'siteplan',
};

export const WEB_CALLBACK_OPEN = 'webCallBack';
export const WEB_CALLBACK_SUBMIT = 'webCallBack_validate';

export const MEETING_EVENT = {
  REQUEST: 'requestForm',
  SEND_REQUEST_SUCCESS: 'CTASendRequest',
  SEND_REQUEST_ERROR: 'CTASendRequest_error',
};

export const OFFER_PUSH = {
  ACTION: 'main_push_offers',
};
